<style scoped>
    .simple-size {
        color: #ccc;
        font-size: 12px;
        height: 20px;
        padding: 0;
        margin: 0;
    }
</style>

<template>
    <div>
        <Modal
                :value="showModel"
                :title="title"
                :footer-hide="true"
                :mask-closable="false"
                @on-cancel="cancel"
                @on-visible-change="openOrClose">
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">

                        <FormItem label="位置名称:" prop="bank_name">
                            <Input type="text" v-model="formData.bank_name"></Input>
                        </FormItem>
                        <FormItem label="位置编码:" prop="bank_code">
                            <Input type="text" v-model="formData.bank_code"></Input>
                        </FormItem>
                        <!--<FormItem label="缩略图：" prop="thumb">-->
                        <!--    <ImgUpload ref="upImg" :action="actionUrlThumb" :hasUpload="hasUpload" :num="num" @setThumbUrl="setThumbUrlthumb"></ImgUpload>-->
                        <!--    <span class="simple-size">大小： 200 * 200</span>-->
                        <!--</FormItem>-->
                        <FormItem label="详细地址:" prop="address">
                            <Input type="text" v-model="formData.address"></Input>
                        </FormItem>
                        <FormItem label="经度:" prop="lng">
                            <Input type="text" v-model="formData.lng"></Input>
                        </FormItem>
                        <FormItem label="纬度:" prop="lat">
                            <Input type="text" v-model="formData.lat"></Input>
                        </FormItem>
                        <FormItem label="打卡范围(m):" prop="clock_distance">
                            <Input type="text" v-model="formData.clock_distance" placeholder="允许打卡的最远距离(m)"></Input>
                        </FormItem>
                        <FormItem>
                            <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
                        </FormItem>

            </Form>

        </Modal>
    </div>
</template>
<script>
    /**
     * 弹框
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import SearchSelect from '../common/selectList';
    import VueNeditorWrap from 'vue-neditor-wrap';
    import FileUpload from "../common/uploadFile";
    import ImgUpload from "../common/upload";
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {
                tabIndex:"1",
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                searchCateUrl: this.config.urlArray.searchArtCate,
                editorConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: this.config.urlArray.articleUploadThumb,
                    // 你的UEditor资源存放的路径,相对于打包后的index.html
                    UEDITOR_HOME_URL: '/neditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 600,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: false
                },
                formData: {//表单数据
                    bank_name: '',
                    bank_code: '',
                    address: '',
                    lat: '',
                    lng:'',
                    clock_distance:'',
                },
                actionUrlThumb: this.config.urlArray.commonUploadImage, //上传图片接口
                actionUrlFile: this.config.urlArray.articleUploadFile, //上传附件接口
                num: 1, //图片上传数量
                hasUpload: [], //已上传图片
                hasUploadFile: [], //已上传附件
                ruleCustom: {//验证
                    bank_name: [
                        {required: true, message: '打卡位置名称不能为空', trigger: 'blur' },
                    ],
                    address: [
                        {required: true, message: '详细地址不能为空', trigger: 'blur' },
                    ],
                    bank_code: [
                        {required: true, message: '位置编码不能为空', trigger: 'blur' },
                    ],
                    lng: [
                        {required: true, message: '经度不能为空', trigger: 'blur' },
                    ],

                    lat: [
                        { required: true, message: "纬度不能为空", trigger: "blur" },
                    ],
                    clock_distances: [
                        {required: true, message: '打卡范围不能为空', trigger: 'blur' },
                        // { type: 'number', pattern: /^[0-9]\d*$/i, message:'排序必须为不小于零的整数', trigger:'blur'},
                    ],
                },
            }
        },
        components: {
            SearchSelect,
            ImgUpload,
            VueNeditorWrap,
            FileUpload
        },
        methods: {
            setSelected(e) {
                this.formData.start_time = e[0]
                this.formData.end_time = e[1]
            },
            setThumbUrlthumb(url) { //获取图片上传后的路径   商品封面图
                this.formData.thumb = url;
            },
            setFileUrlthumb(url) { //获取附件上传后的路径
                this.formData.download_url = url;
            },
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.bank_name = this.editFormData.bank_name.toString();
                        this.formData.bank_code = this.editFormData.bank_code.toString();
                        this.formData.address = this.editFormData.address.toString();
                        this.formData.lat = this.editFormData.lat;
                        this.formData.lng = this.editFormData.lng;
                        this.formData.clock_distance = this.editFormData.clock_distance;

                        // setTimeout(() => {
                        //     this.$refs.apply_val.setDefVal(Number(this.formData.cate_id));
                        // }, 500);

                    }
                    this.title = this.type == 1?'添加打卡位置':'编辑打卡位置'
                } else { //关闭弹框后要做的处理

                    // this.$refs.upFile.clearImg()//清除已上传的图片
                    // this.$refs.upImg.clearImg()//清除已上传的图片
                    // this.$refs.apply_val.clearVal();
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                        }

                        this.axios.post(this.config.urlArray.bankStore, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },
            setSelectVal(data,key){
                this.formData[key] = data.toString()
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.tabIndex = '1'
                // this.$refs.upFile.clearImg()//清除已上传的图片
                // this.$refs.upImg.clearImg()//清除已上传的图片
                // this.$refs.apply_val.clearVal();
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
